import { CommonEnums } from '../../common.enums';

export class SearchItem {
    obj_Id: number;
    objNm: string;
    selected: boolean;

    constructor() {
        this.obj_Id = CommonEnums.defaults.LONG_VAL;
        this.objNm = CommonEnums.defaults.STRING_EMPTY;
        this.selected = false;
    }

    static parse( searchItemTmp: SearchItem ): SearchItem {
        let searchItem: SearchItem = new SearchItem();
        searchItem.copyFrom( searchItemTmp );

        return searchItem;
    }

    copy(): SearchItem {
        let searchItemTmp: SearchItem = new SearchItem();

        searchItemTmp.obj_Id = this.obj_Id;
        searchItemTmp.objNm = this.objNm;
        searchItemTmp.selected = this.selected;

        return searchItemTmp;
    }

    copyFrom( searchItemTmp: SearchItem ): void {
        this.obj_Id = searchItemTmp.obj_Id;
        this.objNm = searchItemTmp.objNm;
        this.selected = searchItemTmp.selected;
    }
}